import { useQuery } from '@tanstack/react-query'
import { CommentsChartMockData } from 'src/pages/ContentAnalysisDetail/mockData/commentsChartMockData'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

interface CommentsResponse {
  data: CommentsChartMockData
}

interface UseGetContentAnalysisCommentsQueryParams {
  fromDate?: string
  id: string
  toDate?: string
}

export const useGetContentAnalysisCommentsQuery = ({
  fromDate,
  id,
  toDate,
}: UseGetContentAnalysisCommentsQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getComments<CommentsResponse>(id, {
        fromDate,
        toDate,
      }),
    queryKey: [QueryKey.GET_CONTENT_ANALYSIS_COMMENTS, id, fromDate, toDate],
  })
}
